import { QueryType } from '../Default';
import { IQueryTypeFragments } from '../../QueryFragments';

const skinToneFragment = `
    on ${QueryType.skus} {
        skin {
            tone {
                key
                value
            }
        }
    }
`;

export const skinToneFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.skus]: skinToneFragment
    };
};
